module.exports = __webpack_public_path__ + "static/img/iso.a9b2d12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/iso.png
// module id = KcZN
// module chunks = 53